"use strict";
const TOKEN_OVERRIDES = {
  "0xf1815bd50389c46847f0bda824ec8da914045d14": {
    name: "USDC",
    symbol: "USDC"
  },
  "0x49c6b2799af2db7404b930f24471dd961cfe18b7": {
    name: "More Flow USDC",
    symbol: "mFlowUSDC"
  }
};
function getTokenOverride(address) {
  return TOKEN_OVERRIDES[address.toLowerCase()];
}
export function formatCurrencySymbol(currency) {
  if (!currency)
    return void 0;
  if (currency.isToken && currency.address) {
    const override = getTokenOverride(currency.address);
    if (override?.symbol) {
      const symbol = override.symbol;
      return symbol.length > 20 ? symbol.slice(0, 4) + "..." + symbol.slice(symbol.length - 5, symbol.length) : symbol;
    }
  }
  return currency.symbol && currency.symbol.length > 20 ? currency.symbol.slice(0, 4) + "..." + currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length) : currency?.symbol;
}
export function getTokenSymbolOverride(address, fallbackSymbol) {
  if (!address)
    return fallbackSymbol || "UNK";
  const override = TOKEN_OVERRIDES[address.toLowerCase()];
  return override?.symbol ?? fallbackSymbol ?? "UNK";
}
export function getTokenNameOverride(address, fallbackName) {
  if (!address)
    return fallbackName || "Unknown";
  const override = TOKEN_OVERRIDES[address.toLowerCase()];
  return override?.name ?? fallbackName ?? "Unknown";
}
